export const UNKOWN_EXCEPTION : string = 'Ocorreu um erro não tratado. Veja mais no console.';
export const FILTRO_COTACOES: string = '@App:filtroCotacoes';
export const FILTRO_ORDENS_SERVICO: string = '@App:filtroOrdensServico';